






































































































































import { Component, Vue } from 'vue-property-decorator';
import {scroller} from 'vue-scrollto/src/scrollTo';
@Component({
  components: {}
})
export default class Learn extends Vue {

    docScroll(id: string): void{
        const firstScrollTo = scroller();
        firstScrollTo(`#${id}`);
    }
};
